module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-prize-awards-sub-about",
    class: [{
      'is-alt': _vm.isAlt
    }],
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subheader', {
    staticStyle: {
      "margin-bottom": "2em"
    },
    attrs: {
      "title": "Here's Your Chance To Win Even If Your Bar-b-que Doesn't"
    }
  }), _vm._v(" "), _c('div-container', _vm._l((_vm.items), function(item, ikey) {
    return (item && item.imageUrl) ? _c('div-columns', {
      key: ("" + ikey),
      attrs: {
        "paddingTop": "0",
        "paddingBottom": "0"
      }
    }, [(item) ? _c('div', {
      staticClass: "columns is-gapless is-centered row"
    }, [_c('div', {
      staticClass: "column is-5 has-text-centered"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.imageUrl,
        "width": "200"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "column is-7 has-text-left"
    }, [_c('h2', {
      staticStyle: {
        "margin-bottom": "0",
        "padding-bottom": "30px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])]) : _vm._e()]) : _vm._e()
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-291407da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AboutPrizeAwardsSubSection.vue
// module id = 907
// module chunks = 1